import { LoadingButton } from "@mui/lab"
import { useState } from "react"
import {useTranslation} from "react-i18next";
import api from "../../../../../Apis";
import Swal from "sweetalert2";

export const ConnectAllFanpage = ({ cookie, lang }) => {
  const [loadingButton, setLoadingButton] = useState(false);
  const {t} = useTranslation();
  const connectAll = () => {
    setLoadingButton(true);
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + cookie
        }
    };
    fetch(api.connect_all_page + `?lang=${lang}`, requestOptions)
    .then(res => res.json())
    .then(
        (result) => {
            if (result.success) {
                setLoadingButton(false);
                Swal.fire("", result.message, "success")
            } else {
                setLoadingButton(false);
                Swal.fire("", result.message, "warning")
            }
        }
    )
}

  return (
    <LoadingButton loading={loadingButton} onClick={connectAll} sx={{marginLeft: '5px'}} type="button" className='text-transform' color="warning" variant="contained">{t('common.connect_all')}</LoadingButton>
  )
}